import * as Blockly from 'blockly/core';

export function register(gen: any): void {
    gen.forBlock['spacer'] = function (_block: Blockly.Block): string {
        return '';
    };
}
